import React, { useEffect, useState } from 'react';
import { genOverviewData } from '../../utils/api';
import './Overview.css';

export default function Overview() {
  const [totalProperties, setTotalProperties] = useState<string | null>(null);
  const [totalPropertiesLastWeek, setTotalPropertiesLastWeek] = useState<string | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [totalPropertiesLastMonth, setTotalPropertiesLastMonth] = useState<string | null>(null);
  const [totalScraperRuns, setTotalScraperRuns] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
        const overviewData = await genOverviewData();
        setTotalProperties(overviewData.totalProperties.toString());
        setTotalPropertiesLastWeek(overviewData.totalPropertiesLastWeek.toString());
        setTotalPropertiesLastMonth(overviewData.totalPropertiesLastMonth.toString());
        setTotalScraperRuns(overviewData.totalScraperRuns.toString());
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'));
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return (
    <div>
      <h1>Overview</h1>
      <div className="metric-rect-container">
        <MetricRect 
          title="Total Properties" 
          value={totalProperties}
          loading={loading}
          error={error}
        />
        <MetricRect 
          title="Active Properties Last Week" 
          value={totalPropertiesLastWeek}
          loading={loading}
          error={error}
        />
        <MetricRect 
          title="Total Scraper Runs" 
          value={totalScraperRuns}
          loading={loading}
          error={error}
        />
      </div>
    </div>
  );
}

interface MetricRectProps {
  title: string;
  value: string | null;
  loading: boolean;
  error: Error | null;
}

function MetricRect({ title, value, loading, error }: MetricRectProps) {
  let displayValue: React.ReactNode;

  if (error) {
    displayValue = `Error loading metric: ${error.message}.`;
  } else if (loading) {
    displayValue = 'Loading...';
  } else {
    displayValue = value;
  }

  return (
    <div className="metric-rect">
      <div className="metric-rect-title">{title}</div>
      <div className="metric-rect-value">{displayValue}</div>
    </div>
  );
}
